import React from 'react';
import { Drawer, List, ListItemIcon, ListItemText, useTheme, useMediaQuery, ListItemButton, Tooltip, Avatar } from '@mui/material';
import { DashboardRounded, HomeRounded } from '@mui/icons-material';
import { AccessList, SuperAdmAccessList } from '../../conf';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../assets/logo.png';

const drawerWidth = 240;
const collapsedWidth = 60;

export default function Sidebar({ collapse }) {
    const user = JSON.parse(sessionStorage.getItem('user'));
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md')); // sm ~ 960px
    const isMedium = collapse || isMediumScreen; // md ~ 960px

    const drawerStyle = {
        width: isMedium ? collapsedWidth : drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        '& .MuiDrawer-paper': {
            width: isMedium ? collapsedWidth : drawerWidth,
            transition: 'width 0.3s',
            overflowX: 'hidden',
            top: '60px', // hauteur de ton AppBar
            height: 'calc(100vh - 60px)', // ne dépasse pas le header
        },
    };

    return (
        <Drawer variant="permanent" sx={drawerStyle}>
            <List component={'nav'} sx={{ flexGrow: 1 }}>
                
                <ListItemButton onClick={() => navigate('/')} selected={location.pathname === '/'}>
                    <Tooltip title="Accueil">
                        <ListItemIcon><HomeRounded /></ListItemIcon>
                    </Tooltip>
                    {!isMedium && <ListItemText sx={{ pointerEvents:'none' }} primary={"Accueil"} />}
                </ListItemButton>
                <ListItemButton onClick={() => navigate('/dashboard')} selected={location.pathname === '/dashboard'}>
                    <Tooltip title="Tableau de bord">
                        <ListItemIcon><DashboardRounded /></ListItemIcon>
                    </Tooltip>
                    {!isMedium && <ListItemText sx={{ pointerEvents:'none' }} primary="Tableau de bord" />}
                </ListItemButton>

                {(user.role === 'admin' ? AccessList.filter(item => user.access.includes(item.label)) : [...AccessList, ...SuperAdmAccessList])
                .sort((a, b) => a.label.localeCompare(b.label))
                .map((item, index) => (
                    <ListItemButton key={index} onClick={() => navigate(item.ref)} selected={location.pathname === item.ref}>
                        <Tooltip title={item.button_title}>
                            <ListItemIcon>{item.icon}</ListItemIcon>
                        </Tooltip>
                        {!isMedium && <ListItemText sx={{ pointerEvents:'none' }} primary={item.button_title} />}
                    </ListItemButton>
                ))}
            </List>


            <List sx={{ mb: -1}}>
                <ListItemButton href={process.env.REACT_APP_MGP_WEB_APP_URL}>
                    <Tooltip title="My Gospel Pass">
                        <ListItemIcon><Avatar src={logo} /></ListItemIcon>
                    </Tooltip>
                    {!isMedium && <ListItemText sx={{ pointerEvents:'none' }} primary={"My Gospel Pass"} />}
                </ListItemButton>
            </List>
        </Drawer>
    );
}
